<template>
  <!-- 患者動態表 -->
  <div id="AppMasterMaintenancePatientDynamics">
      <!-- 上部余白 -->
      <div style="height: 20px;" />
      <div v-if="patientDb.disable" style="margin-left: 50px; margin-right: 50px;">
        <div class="columns">
          <div class="column is-one-third">
            <b-field class="file">
                <b-upload v-model="uploadfile"
                  v-on:input="changeUploadfile">
                    <a class="button is-primary" style="width: 270px;">
                        <b-icon icon="upload"></b-icon>
                        <span>患者動態表アップロード</span>
                    </a>
                </b-upload>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field class="file">
              <b-button
                class="button is-primary has-text-centered"
                icon-left="download"
                native-type="button"
                v-on:click="doDownload">患者動態表ダウンロード（更新）</b-button>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field class="file">
              <b-button
                class="button is-primary has-text-centered"
                icon-left="download"
                native-type="button"
                v-on:click="doNewDownload">患者動態表ダウンロード（新規）</b-button>
            </b-field>
          </div>
        </div>
        <div class="columns">
          <div class="column is-one-third">
            <b-field class="file">
              <b-button
                class="button is-primary has-text-centered"
                style="width: 270px;"
                icon-left="download"
                native-type="button"
                v-on:click="showListDownloadModal">アップロード未更新リスト取得</b-button>
            </b-field>
            <b-modal :active.sync="isListDownloadModalActive" has-modal-card>
              <listDownload-modal></listDownload-modal>
            </b-modal>
          </div>
        </div>
      </div>

      <div v-else style="margin-left: 50px; margin-right: 50px;">
        <div class="columns">
          <div class="column is-one-third">
            <b-field class="file">
              <b-upload v-model="pathientDbFile"
                v-on:input="uploadFilePatientDb()">
                  <a class="button is-primary" style="width: 270px;">
                    <b-icon icon="upload"></b-icon>
                    <span>患者DB連携アップロード</span>
                  </a>
              </b-upload>
            </b-field>
          </div>
          <div class="column is-one-third">
            <b-field class="file">
              <b-button
                class="button is-primary has-text-centered"
                icon-left="download"
                native-type="button"
                v-on:click="downloadFilePatientDb()">患者DB連携ダウンロード</b-button>
            </b-field>
          </div>
        </div>
      </div>
      <!-- 下部余白 -->

      <div style="height: 10px;" />
  </div>
</template>

<script>
const ListDownloadModalForm = {

  data() {
    var toDay = new Date();
    return {
      startDate: toDay,
      endDate: toDay
    }
  },
  methods: {
    doownLoad: function(event) {
      this.startDate.setHours(0);
      this.startDate.setMinutes(0);
      this.startDate.setSeconds(0);
      this.startDate.setMilliseconds(0);
      this.endDate.setHours(0);
      this.endDate.setMinutes(0);
      this.endDate.setSeconds(0);
      this.endDate.setMilliseconds(0);
      //開始日<=終了日のチェック
      if(this.startDate > this.endDate){
        // エラーメッセージ表示
        this.showErrorMessage("終了日は開始日以降の日付を選択してください。");
      } else {
        //ダウンロードAPI call
        this.doListDownload();
      }
    },
    doListDownload: function(dateRange) {
      var excuteApi = this.downloadPartiallyUpdatedListFilePOST
      var errorCallBack = this.downloadFileError
      // WebAPI Call
      this.downloadApiCall(excuteApi,errorCallBack)
      //モーダルを閉じる
      this.$parent.close();
    },
    downloadPartiallyUpdatedListFilePOST: function (client){
      var startDateStr = this.formatDate2(this.startDate);
      var endDateStr   = this.formatDate2(this.endDate);
      return client.apis.apiMaster.downloadPartiallyUpdatedListFilePOST({
        body: {
          startDate: startDateStr,
          endDate: endDateStr
        }
      })
    },
    downloadFileError: function (result) {
      this.showErrorMessage(result)
    }
  },
  template: `
        <form action="">
          <div class="modal-card" style="width: 700px;">
            <header class="modal-card-head">
                <p class="modal-card-title" style="color: whitesmoke;">アップロード未更新リスト取得</p>
            </header>
            <section class="modal-card-body">
              <div class="columns">
                <div horizontal class="column">
                  <b-field label="開始日付" labelPosition="on-border" >
                    <b-datepicker
                      v-model="startDate"
                      name="startDate"
                      type="day"
                      placeholder="開始日付"
                      icon="calendar-today"
                      :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                      :day-names="['日','月','火','水','木','金','土']"
                      inline
                    ></b-datepicker>
                  </b-field>
                </div>
                <div horizontal class="column">
                  <b-field label="終了日付" labelPosition="on-border">
                    <b-datepicker
                      v-model="endDate"
                      name="endDate"
                      type="day"
                      placeholder="終了日付"
                      icon="calendar-today"
                      :month-names="['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']"
                      :day-names="['日','月','火','水','木','金','土']"
                      inline
                    ></b-datepicker>
                  </b-field>
                </div>
              </div>
            </section>
            <footer class="modal-card-foot">
                <button class="button" type="button" @click="doownLoad">ダウンロード</button>
                <button class="button" type="button" @click="$parent.close()">閉じる</button>
            </footer>
          </div>
        </form>
      `
};
export default {
  name: 'AppMasterMaintenancePatientDynamics',
  methods: {
    changeUploadfile: function () {
      var excuteApi = this.uploadPatientInspectionFilePOST
      var successCallBack = this.uploadSuccess
      var errorCallBack = this.uploadError
      // WebAPI Call
      this.uploadApiCall(excuteApi,successCallBack,errorCallBack)
    },
    uploadPatientInspectionFilePOST: function (client) {
      console.log('uploadfile ='+ this.uploadfile)
      return client.apis.apiMaster.uploadPatientInspectionFilePOST({
        upfile : this.uploadfile
      })
    },
    uploadSuccess: function (result) {
      // WebAPI応答内容を画面に設定
      this.showSuccess(result)
      this.uploadfile = null
    },
    uploadError: function (result) {
      this.showErrorMessage(result)
      this.uploadfile = null
    },
    doDownload: function () {
      var excuteApi = this.downloadPatientInspectionFilePOST
      var errorCallBack = this.downloadFileError
      // WebAPI Call
      this.downloadApiCall(excuteApi,errorCallBack)
    },
    doNewDownload: function () {
      var excuteApi = this.downloadPatientInspectionNewFilePOST
      var errorCallBack = this.downloadFileError
      // WebAPI Call
      this.downloadApiCall(excuteApi,errorCallBack)
    },
    downloadPatientInspectionFilePOST: function (client) {
      return client.apis.apiMaster.downloadPatientInspectionFilePOST()
    },
    downloadPatientInspectionNewFilePOST: function (client) {
      return client.apis.apiMaster.downloadPatientInspectionNewFilePOST()
    },
    downloadFileError: function (result) {
      this.showErrorMessage(result)
    },
    showListDownloadModal: function(event) {
      // 一部未更新リスト取得画面表示
      this.isListDownloadModalActive = true;
    },

    uploadFilePatientDb: function () {
      var excuteApi = this.uploadPatientDbFile;
      var successCallBack = this.uploadPatientDbFileSuccess;
      var errorCallBack = this.uploadPatientDbFileError;
      // WebAPI Call
      this.uploadApiCall(excuteApi, successCallBack, errorCallBack);
    },

    uploadPatientDbFile: function (client) {
      return client.apis.apiMaster.uploadPatientDbFilePOST({
        upfile: this.pathientDbFile,
      });
    },

    uploadPatientDbFileSuccess: function (result) {
      // WebAPI応答内容を画面に設定
      this.showSuccess(result);
      this.pathientDbFile = null;
    },

    uploadPatientDbFileError: function (result) {
      this.showErrorMessage(result);
      this.pathientDbFile = null;
    },

    downloadFilePatientDb: function () {
      var excuteApi = this.downloadPatientDbFilePOST;
      var errorCallBack = this.showErrorMessage;
      // WebAPI Call
      this.downloadApiCall(excuteApi, errorCallBack);
    },

    downloadPatientDbFilePOST: function (client) {
      return client.apis.apiMaster.downloadPatientDbFilePOST()
    },
  },
  data () {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    return {
      uploadfile:null,
      isListDownloadModalActive: false,
      pathientDbFile: null,
      patientDb: userInfo.system.patientDb,
    }
  },
  filters: {
  },
  components: {
    "listDownload-modal": ListDownloadModalForm
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AppMasterMaintenancePatientDynamics.vue